import { FC } from 'react'
import { useAcceptCookies } from 'hooks/use-accept-cookies'
import { Button, Link } from 'components/ui'
import cn from 'classnames'
import type { AcceptCookiesProps } from '.'
import s from './accept-cookies.module.css'

const AcceptCookies: FC<AcceptCookiesProps> = () => {
  const { acceptedCookies, onAcceptCookies } = useAcceptCookies()
  const hide = acceptedCookies

  const rootClassName = cn(s.root, {
    transform: true,
    'translate-y-0 opacity-100': !hide,
    'translate-y-full opacity-0': hide,
  })

  return (
    <div className={rootClassName}>
      <div className={s.content}>
        Esse site utiliza cookies para melhorar a sua experiência de navegação. Consulte nossa{' '}
        <Link href="/politica-de-privacidade">
          <u>política de privacidade</u>
        </Link>
        .
      </div>
      <Button onClick={onAcceptCookies}>Aceitar</Button>
    </div>
  )
}

export default AcceptCookies
